<template>
  <div id="systemResourceWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Input
          v-model="searchValue"
          prefix="ios-search-outline"
          placeholder="请服务器名称"
          style="width: 208px; margin-right: 10px;"
          @on-enter="handleSearchClick"
        />
        <Button type="primary" @click="handleSearchClick">搜索</Button>
      </div>
      <div>
        <Button type="primary" icon="ios-add" @click="handleAddClick">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :columns="Columns"
      :tableData="tableData"
      :tableHeight="tableHeight"
      @on-btn-click="onBtnClick"
    ></el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page
        :total="totalCount"
        @on-change="handlePagingClick"
      />
    </div>
  </div>
</template>
<script>
import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
import ElTable from '_g/commonComponent/table/elTable.vue';
import Columns from './tableConfig.js'
export default {
  components: {
    'el-table': ElTable
  },
  data() {
    return {
      tableData: [
        {
          name: 'John Brown',
          age: 18,
          address: 'New York No. 1 Lake Park',
          id: 667,
          dto: {
            sex: 2,
            job: 'wewe'
          },
          inputValue: 23,
        }
      ], // 数据
      Columns: [], // 表头
      totalCount: 100, // 总条数
      tableHeight: 0,
      searchValue: '', // 搜索框的值
    }
  },
  methods:{
    // 获取元素的高度
    getElementHeight() {
      let ERD = elementResizeDetectorMaker();
      let _this = this;
      ERD.listenTo(document.getElementById("systemResourceWrapper"), (element) => {
       _this.tableHeight = (element.scrollHeight - 66 - 90);
      });
    },
    // 操作按钮
    onBtnClick(rowItem, options) {
    },
    // 新建功能
    handleAddClick() {
    },
    // 搜索功能
    handleSearchClick() {
    },
    // 分页功能
    handlePagingClick(res) {
    }
  },
  mounted() {
    this.Columns = Columns;
    // 获取元素高度
    this.getElementHeight();
  }
}
</script>
<style lang="less" scoped>
#systemResourceWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  .search-box {
    width: 100%;
    height: 66px;
    padding: 22px 0px 12px 0px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .paging-box {
    position: fixed;
    bottom: 0px;
    right: 50px;
    z-index: 1;
    height: 60px;
    width: calc(100% - 250);
    text-align: right;
  }
}
</style>